import { render, staticRenderFns } from "./IlluDiplome.vue?vue&type=template&id=1022aa56&"
import script from "./IlluDiplome.vue?vue&type=script&lang=js&"
export * from "./IlluDiplome.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports